/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWUserStat } from './OWUserStat';
import {
    OWUserStatFromJSON,
    OWUserStatFromJSONTyped,
    OWUserStatToJSON,
    OWUserStatToJSONTyped,
} from './OWUserStat';

/**
 * 
 * @export
 * @interface GetUserStatsResponse
 */
export interface GetUserStatsResponse {
    /**
     * 
     * @type {string}
     * @memberof GetUserStatsResponse
     */
    message?: string;
    /**
     * 
     * @type {Array<OWUserStat>}
     * @memberof GetUserStatsResponse
     */
    userStats?: Array<OWUserStat>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetUserStatsResponse
     */
    uniqueGameIds?: Array<string>;
}

/**
 * Check if a given object implements the GetUserStatsResponse interface.
 */
export function instanceOfGetUserStatsResponse(value: object): value is GetUserStatsResponse {
    return true;
}

export function GetUserStatsResponseFromJSON(json: any): GetUserStatsResponse {
    return GetUserStatsResponseFromJSONTyped(json, false);
}

export function GetUserStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'] == null ? undefined : json['message'],
        'userStats': json['userStats'] == null ? undefined : ((json['userStats'] as Array<any>).map(OWUserStatFromJSON)),
        'uniqueGameIds': json['uniqueGameIds'] == null ? undefined : json['uniqueGameIds'],
    };
}

export function GetUserStatsResponseToJSON(json: any): GetUserStatsResponse {
    return GetUserStatsResponseToJSONTyped(json, false);
}

export function GetUserStatsResponseToJSONTyped(value?: GetUserStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'userStats': value['userStats'] == null ? undefined : ((value['userStats'] as Array<any>).map(OWUserStatToJSON)),
        'uniqueGameIds': value['uniqueGameIds'],
    };
}

